<template>
	<div class="row faq">
		<h2>{{ header }}</h2>
		<div v-if="content" class="faq-content" v-html="content" />
		<div v-if="content" class="contact-info">
			<a :href="`tel:${$phoneRaw(defaults[locale].website.phone)}`">
				<font-awesome-icon icon="fal fa-phone" size="1x" />
				<span>{{ defaults[locale].website.phone }}</span> </a
			><br />
			<a :href="`mailto:${defaults[locale].website.email}`">
				<font-awesome-icon icon="fal fa-envelope" size="1x" />
				<span>{{ defaults[locale].website.email }}</span>
			</a>
		</div>
		<div v-for="item in items" :key="item.ID" class="columns column12 faq-item">
			<collapse :header="item.question" :content="item.answer" />
		</div>
	</div>
</template>

<script setup>
const config = useRuntimeConfig();

const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

const props = defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	items: { type: Array, default: () => [] },
});

await fetchDefaults();

function stripHtml(html) {
	//eslint-disable-next-line
	if (typeof html !== 'string') return '';

	return html.replace(/<[^>]*>/g, '').trim();
}

if (props.items.length) {
	const faqSchema = {
		'@context': 'https://schema.org',
		'@type': 'FAQPage',
		name: `Official ${defaults.value[locale.value].website.hotelName} FAQ`,
		about: {
			'@type': 'Hotel',
			'@id': `${config.public.siteUrl}#hotel`,
		},
		mainEntity: props.items.map((item) => ({
			'@type': 'Question',
			name: item.question,
			acceptedAnswer: {
				'@type': 'Answer',
				text: stripHtml(item.answer),
			},
		})),
	};

	useHead({
		script: [
			{
				type: 'application/ld+json',
				innerHTML: JSON.stringify(faqSchema),
			},
		],
	});
}
</script>

<style lang="scss" scoped>
.row {
	overflow: hidden;
	width: 100%;
	display: inline-block;
	vertical-align: top;
	padding-bottom: 75px;
	text-align: left;

	.faq-content {
		text-align: center;

		:deep(p) {
			margin-top: 0;
		}
	}

	&:last-child {
		padding-bottom: 0;
	}

	h2 {
		margin-bottom: 50px;
		text-align: center;
	}
}

.contact-info {
	text-align: center;
	display: flex;
	flex-flow: row wrap;
	justify-content: center;
	align-items: center;
	gap: 25px;
	margin: 20px auto;

	a {
		color: #000;

		span {
			font-size: 18px;
			font-weight: 500;
		}

		svg {
			color: #0f7c41;
			margin: 0 5px 0 0;
			font-size: 20px;
		}
	}
}

@media (max-width: 960px) {
	.faq-item {
		padding: 5px 15px;
	}
}
</style>
